// Detects any HTML tag like <div>, <br />, <img src="...">, etc.
const htmlRegex = /<[^>]+>/;

const hasHTML = (content: string): boolean => {
  if (!content) return false;

  return htmlRegex.test(content);
};

export const needsEmbedding = (content: string) => {
  return (
    content.includes('<!DOCTYPE') ||
    content.includes('<!doctype') ||
    content.includes('<DOCTYPE') ||
    content.includes('<doctype')
  );
};

export const checkIsComplex = (content: string) => {
  return needsEmbedding(content) || hasHTML(content);
};
